import { createFileRoute } from "@tanstack/react-router";
import { EditContent, Settings } from "@/features/consent-solutions";

const Route = createFileRoute("/_authorized/consent-solutions/$csId/settings/")({
  component: () => (
    <EditContent>
      <Settings />
    </EditContent>
  ),
});

export { Route };
